import _ from "lodash";
import ACTIONS from "../actions/PricingTablesActions";
import {PricingTableSortFields} from "../constants/PricingTablesActionConstants";
import SortDirection from "../../../common/constants/SortDirection";
import {listPageGlobalFilter} from "../../../common/utils/FilterFunctions";

const initialState = {
    pricingTablesV2: [],
    filteredPricingTablesV2: [],
    pricingTableDetailsV2: {},
    basePrice: null,
    countryPricesV2: {},
    pricingTableTenants: [],
    duplicateCountries: [],
    updatedPricingTable: false,
    pricingTableSortKey: PricingTableSortFields.NAME,
    pricingTableSortDirection: SortDirection.ASC,
}

const pricingTablesReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.PricingTablesActionTypes.PRICING_TABLE_GLOBAL_SEARCH_V2: {
            let newState = _.cloneDeep(state);
            newState.filteredPricingTablesV2 = listPageGlobalFilter(action.payload, newState.pricingTablesV2);

            return newState;
        }

        case ACTIONS.PricingTablesActionTypes.TOGGLE_PRICING_TABLE_SORT_V2: {
            let newState = _.cloneDeep(state);
            newState.pricingTableSortDirection = newState.pricingTableSortDirection === SortDirection.ASC
                ? SortDirection.DESC : SortDirection.ASC;

            if (newState.pricingTableSortDirection === SortDirection.ASC) {
                // check if the requested sort is for a string value
                // separating this out as there might be null values associated with other sortable headers
                if (action.payload === PricingTableSortFields.NAME) {
                    newState.filteredPricingTablesV2 = _.sortBy(newState.filteredPricingTablesV2,
                        [s => s[action.payload].toString().toLowerCase()], [action.payload]);
                } else {
                    newState.filteredPricingTablesV2 = _.sortBy(newState.filteredPricingTablesV2,
                        [s => s[action.payload]], [action.payload]);
                }
            } else {
                if (action.payload === PricingTableSortFields.NAME) {
                    newState.filteredPricingTablesV2 = _.sortBy(newState.filteredPricingTablesV2,
                        [s => s[action.payload].toString().toLowerCase()], [action.payload]).reverse();
                } else {
                    newState.filteredPricingTablesV2 = _.sortBy(newState.filteredPricingTablesV2,
                        [s => s[action.payload]], [action.payload]).reverse();
                }
            }

            newState.pricingTableSortKey = action.payload;
            return newState;
        }

        case ACTIONS.PricingTablesActionTypes.SET_PRICING_TABLES_V2: {
            let newState = _.cloneDeep(state);
            newState.pricingTablesV2 = action.payload;
            newState.filteredPricingTablesV2 = action.payload;
            return newState;
        }

        case ACTIONS.PricingTablesActionTypes.SET_PRICING_TABLE_DETAILS_V2: {
            let newState = _.cloneDeep(state);
            newState.pricingTableDetailsV2 = action.payload.pricingTableDetailsV2.pricingTable;
            newState.pricingTableTenants = action.payload.pricingTableDetailsV2.tenants;
            return newState;
        }

        case ACTIONS.PricingTablesActionTypes.UPDATED_PRICING_TABLE_REFRESH_V2: {
            let newState = _.cloneDeep(state);
            newState.updatedPricingTableV2 = !newState.updatedPricingTableV2;
            return newState;
        }

        case ACTIONS.PricingTablesActionTypes.CLEAR_PRICING_DETAILS_V2: {
            return initialState;
        }

        case ACTIONS.CountryPricingActionTypes.SET_COUNTRY_PRICING_DETAILS_V2: {
            let newState = _.cloneDeep(state);
            const payloadClone = {...action.payload.countryPricesV2}
            const {
                BASE_PRICE, FLAT, ...tierPrices
            } = payloadClone;
            const filteredFlat = {
                FLAT: payloadClone.FLAT.filter((item => item.country_code !== 'ZZ'))
            }
            const countryPrices = filteredFlat.FLAT.length ? {...filteredFlat, ...tierPrices} : {...tierPrices};
            newState.basePrice = payloadClone.BASE_PRICE
            newState.countryPricesV2 = countryPrices;
            return newState;
        }

        default:
            return state;
    }
}

export default pricingTablesReducer
